import {MobileMenu} from './mobile-menu';

$(function() {
  // ---------------------------------------------------------
  // Mobile Menu
  const menuOptions = {
    menuToggle: '.js-mobile-menu-trigger',
  };

  const menu = new MobileMenu(menuOptions);
  menu.$menuToggle.on('click', (e) => {
    e.stopPropagation();
    menu.toggleMobile(e);
  });

  window.onresize = menu.resetMobileMenu;
});
